import { mapActions, mapGetters } from 'vuex'
import {  paddleProrationUpdatePlanApi,
          addNewItemsSubscriptionPreviewApi,
          addNewItemsSubscriptionUpdateApi,
          removeItemsSubscriptionUpdateApi,
          calculatePaddleCustomerCustomDataApi,
          getActivePaddleProductsApi,
          getPaddleCustomerActiveSubscriptionsApi,
          getOneTimeAddonsImmediatelySubscriptionApi,
          registerOrganizationApi,
          createPaddleCustomerAPI,
          createPaddleCustomerAddressAPI,
          createPaddleTransactionAPI,
        } from '@/api/paddle'

import { URLMixins } from "@/mixins/url/url-with-domain";
import { generateToken } from '@/api/signup'

export const paddleMixin = {
  mixins: [URLMixins],
  data () {
    return {
        allPaddleLimits : ['limitStaff', 'limitStudents', 'limitParents', 'limitStorage', 'limitSMS'],

        currency_symbols: {
          GBP: '£',
          USD: '$',
          // Add more currencies as needed
        },
        local_customer_id: '',
        paddle_ctm_id: '',

        paddle_product_id: '',
        paddle_active_subscription: '',

        /* variables for staff
            this feature will limit the number of staff to be added in the organization
        */
        addStaffBtnDis: true,
        totalStaffPurchased: 0,
        totalStaff: 0,

        /* variables for students
        this feature will limit the number of students to be enroll in a course within the organization
        */
        newEnrollmentBtn: true,
        totalStudentsPurchased: 0,
        totalStudents: 0,

        /* variables for staff
            this feature will limit the number of parents to be added in the organization
        */
        totalParentsPurchased: 0,
        totalParents: 0,

        // Other for SOLO plan
        completeSignUpProcessLoader: false,

        paddleCustomerID : null,
        paddleCustomerAddressID: null,
        paddleCustomerAddressCreatedStatus: null,
        paddleTransactionID: null,
        paddleTransactionItems: null,
        paddleTransactionCreatedStatus: null,
    }
  },
  created () {
    console.log('== CREATED PADDLE MIXIN ==')
  },
  computed: {
    ...mapGetters([
                    'get_paddle_staff_create_limit',
                    'get_paddle_staff_create_unlimited',
                    'get_remaining_paddle_staff_units',

                    'get_paddle_student_enroll_limit',
                    'get_paddle_student_enroll_unlimited',
                    'get_paddle_student_enroll_rem_units',

                    'get_paddle_parents_limit',
                    'get_paddle_parents_unlimited',
                    'get_paddle_parents_rem_units',
                  ])
  },
  mounted() {

  },
  methods: {
    ...mapActions([
        'SET_PADDLE_STAFF_CREATE_LIMIT',
        'SET_PADDLE_STAFF_CREATE_UNLIMITED',
        'SET_REM_PADDLE_STAFF_UNITS',

        'SET_PADDLE_STUDENTS_ENROLL_LIMIT',
        'SET_PADDLE_STUDENTS_ENROLL_UNLIMITED',
        'SET_PADDLE_STUDENTS_ENROLL_REM_UNITS',

        'SET_PADDLE_PARENTS_LIMIT',
        'SET_PADDLE_PARENTS_UNLIMITED',
        'SET_PADDLE_PARENTS_REM_UNITS',
    ]),

    // === PADDLE API CALLS

    async getOneTimeAddonsImmediatelySubscription () {
      try {
          const paddle_payload = {
              ctm_id : this.paddle_ctm_id // paddle customer id
          }
          const data = await getOneTimeAddonsImmediatelySubscriptionApi(paddle_payload);
          console.log('getOneTimeAddonsImmediatelySubscription data: ', data.data.data);
          return data.data.data;
      } catch (error) {
          console.log('Error in getOneTimeAddonsImmediatelySubscription: ', error);
      }
    },

    // proration change base plan
    async paddleProrationUpdatePlan(new_price, subscription_id) {
      try {
          this.$vs.loading({
              text: 'Updating plan, Please wait...'
          })
          const paddle_payload = {
            proration_billing_mode : 'prorated_immediately',
            items : [{
              price_id : new_price.id,
              quantity : 1
            }]
          }

          const main_payload = {
            paddle_payload: paddle_payload,
            new_price: new_price
          }
          console.log('paddle_payload: ', paddle_payload)
          console.log('main_payload: ', main_payload)
          const data = await paddleProrationUpdatePlanApi(main_payload, subscription_id);
          console.log('paddleProrationUpdatePlan data: ', data);

          this.current_paddle_subscribed_price.id = this.upgrade_price_id
          this.current_paddle_subscribed_product_id = this.upgrade_product_id

          this.alertMessage = 'Plan has been changed successfully'
          this.alertColor = 'success'
          this.displayAlert = true
          this.showSuccessMessage('Success', data.data.message, 'success')
          this.$vs.loading.close()
          setTimeout(() => {
            window.location.reload()
          }, 1500);
      } catch (error) {
          this.$vs.loading.close()
          if (!error.data.data.status) {
            this.alertMessage = error.data.data.message
            this.alertColor = 'danger'
            this.displayAlert = true
            console.log('Error in paddleProrationUpdatePlan: ', error.data.data.message);
            this.showSuccessMessage('Error', error.data.message, 'danger', 6000)
          } else {
            this.showSuccessMessage('Error', 'Something went wrong', 'danger')
          }
          console.log('Error in paddleProrationUpdatePlan: ', error);
          console.log('Error in paddleProrationUpdatePlan: ', error.data);
          console.log('Error in paddleProrationUpdatePlan: ', error.data.data);
      }
    },

    // payment script initialize
    paddleSignupPaymentInitialize(price_id, email, userData)
    {
      console.log('paddleSignupPaymentInitialize mixin called')
      console.log('price_id: ', price_id)
      console.log('email: ', email)
      console.log('userData: ', userData)
      console.log('VUE_APP_PADDLE_ENV: ', process.env.VUE_APP_PADDLE_ENV)
      console.log('VUE_APP_PADDLE_CLIENT_TOKEN: ', process.env.VUE_APP_PADDLE_CLIENT_TOKEN)

      try
      {
        // Create a script element
        const script = document.createElement('script');
        script.src = 'https://cdn.paddle.com/paddle/v2/paddle.js';
        script.onload = () => {
          console.log('script.onload')
          // Initialize Paddle after the script is loaded
          if (process.env.VUE_APP_PADDLE_ENV === 'sandbox') {
            Paddle.Environment.set("sandbox");
          }
          Paddle.Initialize({
            token: process.env.VUE_APP_PADDLE_CLIENT_TOKEN, // replace with a client-side token
            // pwAuth: '00000000000000000000000000000000', // replace with your Retain API key
            pwCustomer: {
              email: email,
            },
            eventCallback: (data) => {
                console.log('eventCallback data: ', data)
                if (data && data.data && data.data.status) {
                  console.log('checkout status :', data.data.status);
                }

                if (data.code === 'validation') {
                  this.showSuccessMessage('Error', data.detail, 'danger')
                }
                // completed
                else if (data.name == "checkout.completed" &&
                    data.data.customer.id &&
                    data.data.status === 'completed'
                    )
                {
                  localStorage.setItem('paddle_ctm_id', data.data.customer.id)
                  localStorage.setItem('paddle_checkout_status', data.name)
                  localStorage.setItem('paddle_payment_status', data.data.status)

                  console.log('completed', data);
                  console.log('customer id', data.data.customer.id);
                  console.log('txn_id', data.data.transaction_id);
                  console.log('txn_item_details', data.data.items);

                  userData = {
                    ...userData,
                    ctm_id: data.data.customer.id,
                    ctm_email: data.data.customer.email, // it is used while checkout process
                    txn_id: data.data.transaction_id,
                    txn_item_details: data.data.items
                  };
                  // call api to update data in our data base
                  setTimeout(() => {
                    this.registerOrganization(userData)
                  }, 500);
                }
                // close
                else if(data.name == "checkout.closed")
                {
                  window.location.reload()
                  console.log('checkout.closed: ', data.data);
                  console.log('checkout.closed status :', data.data.status);
                }
            }
          });

          console.log('eventCallback out');

          Paddle.Checkout.open({
            settings: {
              displayMode: "overlay",
              theme: "light",
              locale: "en"
            },
            items: [
              {
                price_id: price_id,
                quantity: 1
              },
            ]
          });
        };

        document.head.appendChild(script);
        console.log('paddleSignupPaymentInitialize end: ')
      } catch (error) {
        console.log('paddleSignupPaymentInitialize error: ', error)
      }
    },

    // Process for SOLO plan (FREE) signup
    // STEP 1
    async createPaddleCustomer(userData)
    {
      try {
        this.completeSignUpProcessLoader = true
        console.log('createPaddleCustomer API Call userData: ', userData)
        const data = await createPaddleCustomerAPI(userData)
        console.log('createPaddleCustomer data: ', data);

        // get paddle customer id
        this.paddleCustomerID = data.data.data.paddle_response.id
        console.log('Paddle Customer ID: ', this.paddleCustomerID);
      }
      catch (error) {
        console.log('Error in createPaddleCustomer: ', error);
        console.log('error.data.message : ', error.data.message);
        this.paddleCustomerID = null;
        this.completeSignUpProcessLoader = false
        // console.log('error.data : ', error.data);
        // console.log('error.data.data : ', error.data.data);
        // console.log('error.data.data.paddle_response : ', error.data.data.paddle_response);
        // console.log('error.data.data.paddle_response.error : ', error.data.data.paddle_response.error);
        // console.log('error.data.data.paddle_response.error.code : ', error.data.data.paddle_response.error.code);

        if (error.data &&
            error.data.data &&
            error.data.data.paddle_response &&
            error.data.data.paddle_response.error)
        {
          if (error.data.data.paddle_response.error.code == 'customer_already_exists')
          {
            this.showSuccessMessage('Error', 'Email has been taken, Please choose another email', 'danger', 6000)
          }
          else
          {
            this.showSuccessMessage('Error', error.data.message, 'danger', 6000)
          }
        }
        else
        {
          this.showSuccessMessage('Error', error.data.message, 'danger', 6000)
        }

      }
    },

    // STEP 2
    async createPaddleCustomerAddress(paddleCustomerID, user_Address)
    {
      console.log('createPaddleCustomerAddress called')
      try {
        const data = await createPaddleCustomerAddressAPI({
                                                            ctm_id : paddleCustomerID,
                                                            address : user_Address
                                                          })

        console.log('createPaddleCustomerAddress data: ', data);
        console.log('createPaddleCustomerAddress address id: ', data.data.data.paddle_response.id);
        console.log('createPaddleCustomerAddress data.status: ', data.status);

        this.paddleCustomerAddressID = data.data.data.paddle_response.id
        this.paddleCustomerAddressCreatedStatus = data.status
      }
      catch (error) {
        this.completeSignUpProcessLoader = false
        console.log('Error in createPaddleCustomerAddress: ', error);
      }
    },

    // STEP 3
    async createPaddleTransaction(paddleCustomerID, paddleCustomerAddressID, priceID)
    {
      try {
        const payload = {
          "items": [
            {
              "quantity": 1,
              "price_id": priceID
            }
          ],
          "customer_id": paddleCustomerID,
          "address_id": paddleCustomerAddressID,
          "currency_code": "USD",
          "collection_mode": "automatic",
          "status": "billed",
        }

        console.log('createPaddleTransaction API Call payload: ', payload)
        const data = await createPaddleTransactionAPI(payload);
        console.log('createPaddleTransaction data: ', data);

        this.paddleTransactionCreatedStatus = data.status

        if (data.data.data.paddle_response && data.data.data.paddle_response.id) {
          console.log('createPaddleTransaction data.data.data.paddle_response.id: ', data.data.data.paddle_response.id);
          this.paddleTransactionID = data.data.data.paddle_response.id
          this.paddleTransactionItems = data.data.data.paddle_response.items
        }
      }
      catch (error) {
        this.completeSignUpProcessLoader = false
        console.log('Error in createPaddleCustomer: ', error);
      }
    },

    // STEP 5
    async registerOrganization(userData)
    {
      this.$vs.loading({
        text: 'Please keep this window open. Your account is currently being set up. Thank you for your patience.'
      })
      try {
          console.log('registerOrganization userData: ', userData)
          console.log('registerOrganization API call start:')
          const data = await registerOrganizationApi(userData);
          console.log('registerOrganization data:' , data)
          console.log('data.data:' , data.data)
          console.log('data.data.data:' , data.data.data)
          console.log('data.data.data.data:' , data.data.data.data)
          this.$vs.loading.close()

          if (data.data.data.data.status == 200)
          {
            localStorage.removeItem('paddle_ctm_id')
            localStorage.removeItem('paddle_checkout_status')
            localStorage.removeItem('paddle_payment_status')
            this.redirectToStaffPortal(userData, data.data.data.data.customer_id)
          }
          else
          {
            this.showSuccessMessage('Error', 'Server Error', 'error', 6000)
            setTimeout(() => {
              window.location.reload()
            }, 1500);
          }

      } catch (error) {
          console.log('Error in registerOrganization: ', error);
          this.$vs.loading.close()
          if (error.data.data.status == 409)
          {
            this.showSuccessMessage('Warning', 'Your subdomain is already booked', 'warning', 6000)
            setTimeout(() => {
              window.location.reload()
            }, 1500);
          }
          else {
            localStorage.removeItem('paddle_ctm_id')
            localStorage.removeItem('paddle_checkout_status')
            localStorage.removeItem('paddle_payment_status')
          }
      }
    },
    async redirectToStaffPortal(userData, local_customer_id)
    {
      this.$vs.loading({
        text: 'Success! Your transaction is complete. Please stay on this page.\n' +
              'You\'ll be redirected to create a password shortly.\n' +
              'We\'ve sent an order confirmation to your email.'
      })
      console.log('redirectToStaffPortal')
      console.log('redirectToStaffPortal email_address: ', userData.email_address)
      console.log('redirectToStaffPortal local_customer_id: ', local_customer_id)
      await generateToken({
                      email: userData.email_address,
                      customer_id: local_customer_id,
                    })
      .then((res1) => {
        console.log('generateToken: res1 ', res1)

        // to redirect to unified portal
        let passwordResetUrl = this.makeUrlDomain(userData.subdomain_name)
        let redirect_path =    passwordResetUrl +
                              'password-setup?token=' +
                              res1.data.data +
                              '&email=' + userData.email_address +
                              '&cid=' + local_customer_id +
                              '&user_type=USER' +
                              '&type=WELCOME'

        // to redirect to staff portal
        // let staffUrl = this.makeUrlDomain('staff')
        // let redirect_path =    staffUrl +
        //                       'pages/Password-setup?token=' +
        //                       res1.data.data +
        //                       '&email=' + userData.email +
        //                       '&cid=' + local_customer_id +
        //                       '&user_type=USER' +
        //                       '&type=WELCOME'

        console.log('redirect_path ', redirect_path)
        window.location.href = redirect_path
      })
      .catch((e) => {
        console.log('redirectToStaffPortal error: ', e)
        this.$vs.loading.close()
      })
    },

    // calculate customdata through subscription
    async calculatePaddleCustomerCustomData()
    {
        try {
            const paddle_payload = {
                ctm_id : this.paddle_ctm_id // paddle customer id
            }

            console.log('calculatePaddleCustomerCustomData API call start:')
            return await calculatePaddleCustomerCustomDataApi(paddle_payload);
        } catch (error) {
            console.log('Error in calculatePaddleCustomerCustomData: ', error);
        }
    },

    // add item to subscription preview
    async addNewItemsSubscriptionPreview(paddle_payload, subscription_id) {
      try {
          console.log('addNewItemsSubscriptionPreviewApi API call start:')
          await addNewItemsSubscriptionPreviewApi(paddle_payload, subscription_id);
      } catch (error) {
          console.log('Error in addNewItemsSubscriptionPreviewApi: ', error);
      }
    },

    // add item to subscription update
    async addNewItemsSubscriptionUpdate(paddle_payload, subscription_id) {
      this.$vs.loading({
          text: 'Updating plan, Please wait...'
      })
      try {
          console.log('addNewItemsSubscriptionUpdate API call start:')
          const data = await addNewItemsSubscriptionUpdateApi(paddle_payload, subscription_id);
          this.$vs.loading.close()
          this.showSuccessMessage('Success', data.data.message, 'success')
          setTimeout(() => {
            window.location.reload()
          }, 1000);
      } catch (error) {
          this.$vs.loading.close()
          console.log('Error in addNewItemsSubscriptionUpdate: ', error);
          this.showSuccessMessage('Error', 'Something went wrong', 'error')
      }
    },

    // remove item to subscription update
    async removeItemsSubscriptionUpdate(paddle_payload, subscription_id) {
      this.$vs.loading({
          text: 'Updating plan, Please wait...'
      })
      try {
          console.log('removeItemsSubscriptionUpdate API call start:')
          const data = await removeItemsSubscriptionUpdateApi(paddle_payload, subscription_id);
          this.$vs.loading.close()
          this.showSuccessMessage('Success', data.data.message, 'success')
          setTimeout(() => {
            window.location.reload()
          }, 1000);
      } catch (error) {
          this.$vs.loading.close()
          console.log('Error in removeItemsSubscriptionUpdate: ', error);
          this.showSuccessMessage('Error', 'Something went wrong', 'error')
      }
    },

    // === OTHER API CALLS
    // === Others
    gotoPaddlePlanList() {
      this.$router.push({
        name: 'paddle-plans-list',
      })
    },
    convertToSymbol(currencyCode) {
      return this.currency_symbols[currencyCode] || currencyCode;
    },
    zeroAmountPrice(amount) {
      // Note: paddle has no plan with 0 amount, now they has minimum 1 as base price
      // In paddle 1 is consitder as 100
      return amount == 0 || amount == 100
    },
    convertAmount(amount) {
        return (amount / 100).toFixed(2)
    },
    getMonthlyPrice(amount) {
      return Math.ceil(amount / 12);
    },
    getCurrencySymbol(currencyCode) {
        return this.convertToSymbol(currencyCode)
    },
    /* Intervals from Paddle
      day, week, month, year
    */
    getFreeTrialPeriod(trialPeriod) {
      // Define a lookup for interval names
      const intervals = {
        day: 'Day',
        week: 'Week',
        month: 'Month',
        year: 'Year',
      };

      // Get the correct interval name and pluralize if needed
      const intervalName = intervals[trialPeriod.interval];
      const pluralizedName = trialPeriod.frequency > 1 ? intervalName + 's' : intervalName;

      // Return the formatted free trial string
      return `${trialPeriod.frequency} ${pluralizedName} Free Trial`;
    },

    // === CHECKING LIMITS ONLY
    checkPaddleStaffCreateLimit ()
    {
        console.log('checkPaddleStaffCreateLimit called');
        console.log('this.get_paddle_staff_create_limit: ', this.get_paddle_staff_create_limit);
        console.log('this.get_paddle_staff_create_unlimited: ', this.get_paddle_staff_create_unlimited);
        console.log('this.get_remaining_paddle_staff_units: ', this.get_remaining_paddle_staff_units);
        if (this.get_paddle_staff_create_limit)
        {
          if (this.get_paddle_staff_create_unlimited) {
            console.log('true 1')
            return true;
          } else if (this.get_remaining_paddle_staff_units > 0) {
            console.log('true 2')
            return true;
          } else {
            console.log('false 3')
            return false
          }
        }
        else {
            console.log('true 4')
          return true
        }
    },
    checkPaddleStudentsLimit ()
    {
        console.log('checkPaddleStudentsLimit called');
        console.log('this.get_paddle_student_enroll_limit: ', this.get_paddle_student_enroll_limit);
        console.log('this.get_paddle_student_enroll_unlimited: ', this.get_paddle_student_enroll_unlimited);
        console.log('this.get_paddle_student_enroll_rem_units: ', this.get_paddle_student_enroll_rem_units);

        if (this.get_paddle_student_enroll_limit)
        {
          if (this.get_paddle_student_enroll_unlimited) {
            console.log('true 1')
            return true;
          } else if (this.get_paddle_student_enroll_rem_units > 0) {
            console.log('true 2')
            return true;
          } else {
            console.log('false 3')
            return false
          }
        } else {
          console.log('true 4')
          return true
        }
    },
  }
}
